/* eslint-disable id-blacklist */
/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line import/no-default-export
export default {
    common: {
        chooseItem: 'Choose {0}',
        description: 'Description',
        settings: 'Settings',
        condition: 'Condition',
        conditions: 'Conditions',
        care: 'Care',
        coordinates: 'Coordinates',
        date: 'Date',
        startDate: 'Start date',
        endDate: 'End date',
        time: 'Time',
        startTime: 'Start time',
        endTime: 'End time',
        start: 'Start',
        end: 'End',
        total: 'Total',
        dateAdded: 'Date added',
        defect: 'Defect',
        defects: 'Defects',
        file: 'File',
        filename: 'File name',
        user: 'User',
        users: 'Users',
        emailAddress: 'E-mail address',
        inspectionStandard: 'Inspection standard',
        inspectionCompositionStandard: 'Inspection / composition standard',
        password: 'Password',
        firstName: 'First name',
        lastName: 'Last name',
        mobileNumber: 'Mobile number',
        officeNumber: 'Office number',
        lastLogin: 'Last login',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
        companies: 'Companies',
        company: 'Company',
        composition: 'Composition',
        addItem: 'Add {0}',
        editItem: 'Edit {0}',
        removeItem: 'Remove {0}',
        findItem: 'Find {0}',
        filterItem: 'Filter {0}',
        saveItem: 'Save {0}',
        showItem: 'Show {0}',
        importItem: 'Import {0}',
        name: 'Name',
        search: 'Search',
        actions: 'Actions',
        edit: 'Edit',
        remove: 'Remove',
        enabled: 'Enabled',
        disabled: 'Disabled',
        enable: 'Enable',
        disable: 'Disable',
        administrator: 'System admin',
        surveyor: 'Surveyor',
        operator: 'Operator',
        client: 'Client',
        clients: 'Clients',
        owner: 'Asset owner',
        owners: 'Asset owners',
        role: 'Role',
        previous: 'Previous',
        next: 'Next',
        location: 'Location',
        object: 'Object',
        objects: 'Objects',
        objectType: 'Object Type',
        objectTypes: 'Object types',
        inspectionType: 'Inspection type',
        inspectionTypes: 'Inspection types',
        survey: 'Survey',
        selectItem: 'Select {0}...',
        searchItem: 'Search {0}...',
        allItems: 'All {0}',
        labels: 'Labels',
        label: 'Label',
        code: 'Code',
        part: 'Part',
        element: 'Element',
        elements: 'Elements',
        remark: 'Remark',
        remarks: 'Remarks',
        saved: 'Data has been successfully saved.',
        show: 'Show',
        hide: 'Hide',
        size: 'Size',
        duration: 'Duration',
        status: 'Status',
        surveys: 'Surveys',
        type: 'Type',
        types: 'Types',
        unit: 'Unit',
        units: 'Units',
        routeNotFound: 'Requested path not found.',
        goToDefaultPage: 'Click here to go to default page (inspections list)',
        select: 'Select',
        deselect: 'Deselect',
        list: 'List',
        map: 'Map',
        surveyReports: 'Surveys',
        reports: 'Reports',
        documentation: 'Documentation',
        system: 'System',
        objectDetails: 'Details object',
        surveyDetails: 'Survey details',
        logout: 'Logout',
        profile: 'Profile',
        dashboard: 'Dashboard',
        title: 'Title',
        permissionError: 'You do not have sufficient permissions for this operation',
        inspectionTemplate: 'Inspection template',
        confirmDeleteItem: 'Are you sure you would like to delete this item?',
        confirmDelete: 'Are you sure you would like to delete "{0}"?',
        confirmMultiDelete: 'Are you sure you would like to delete all items?',
        projectNumber: 'Report number',
        category: 'Category',
        manifestation: 'Manifestation',
        manifestations: 'Manifestations',
        files: 'Files',
        cost: 'Cost',
        year: 'Year',
        other: 'Other',
        cut: 'Cut',
        copy: 'Copy',
        annotations: 'Annotations',
        isActive: 'Active',
        language: 'Language',
        yes: 'Yes',
        no: 'No',
        archive: 'Archive',
        material: 'Material',
        top: 'Move to top',
        up: 'Move up',
        down: 'Move down',
        recipient: 'Recipient',
        submit: 'Submit',
        quantity: 'Quantity',
        pcs: 'pcs',
        export: 'Export',
        visuals: 'Visuals',
        added: 'added',
        general: 'General',
        dimensions: 'Dimensions',
        classification: 'Classification',
        move: 'Move',
        measurements: 'Measurements',
        priority: 'Priority',
        isArchived: 'Disabled',
        softwareVersion: 'Software version',
        period: 'Period',
        reset: 'Reset',
        result: 'Result',
        from: 'from',
        to: 'to',
        progress: 'Progress',
        non: 'Non',
        explanation: 'Explanation',
        missingTranslationKey: 'Missing translation key',
        province: 'Province',
        municipality: 'Municipality',
        days: 'Days',
        history: 'History',
        generate: 'Generate',
        amount: 'Amount',
        totalAmount: 'Total amount',
        usage: 'Usage',
        today: 'Today',
        conditionReport: 'Condition report',
        inspectionReport: 'Inspection report',
        dateInspection: 'Inspection date',
        dateReport: 'Report date',
        inspector: 'Inspector',
        constructionYear: 'Construction year',
        advice: 'Advice',
        seriousness: 'Seriousness',
        intensity: 'Intensity',
        extend: 'Extend',
        measures: 'Measures',
        images: 'Visuals',
        imagesExplanation: 'Supporting visual material in the condition report',
        noImages: 'No photos available or no photos selected for',
        all: 'All',
        excelExport: 'Excel export',
        id: 'Id',
        field: 'Field',
        value: 'Value',
        selectedPoint: 'Selected point',
        order: 'Order',
        conductedPeriod: 'Conducted in period:',
        assessment: 'Assessment',
        showAll: 'Show all',
        showLess: 'Show less',
        template: 'Template',
        productReports: 'Products',
        dateRange: 'Date range:',
        product: 'Product',
        invalidId: 'invalid ID',
        doesNotExistAnymore: 'does not exist (anymore)',
        noAccess: 'No access',
        update: 'Update',
        bulkUpdate: 'Bulk update',
        on: 'on',
        off: 'off',
        searchText: 'Provide text to search for',
    },
    asset: {
        filterOnLabel: 'Filter documents by labels',
        filterOnText: 'Filter documents by text',
        search: 'Search',
        manageLabelsModal: 'Manage labels for document',
        addRemoveLabels: 'Select labels you want to apply to "{0}" document',
        errorStorageLimitReached: 'Storage limit reached, cannot upload asset.',
        errorFileTooBig: 'File is too big.',
        asset: 'Asset',
        iconTitleAssetsAvailable: 'Visuals available',
        remove360: 'No panorama',
        set360: 'Set panorama',
        processingVideo: 'Processing video',
        processingThumbnail: 'Creating thumbnail',
        showGallery: 'Show image gallery',
        showColumns: 'Show columns',
        settings: 'Asset settings',
    },
    defect: {
        customDefect: 'Custom defect',
        description: 'Defect description',
        seriousness: 'Seriousness',
        intensity: 'Intensity',
        extend: 'Extend',
        defectSpec: 'Defect specifications',
    },
    login: {
        enterEmailAddress: 'Enter e-mail address',
        enterPassword: 'Enter password',
        signIn: 'Sign in',
        forgotPassword: 'Forgot password?',
        moreInformation: 'For more information about ZXY cloud',
        clickHere: 'click here',
        failMessage: 'E-mail address and password do not match. After too many attempts your account will be temporary blocked.',
        blocked: 'Account has been blocked. Too many unsuccessful login attempts.',
        tempLogin: 'Request login ... please wait.',
        tempLoginFailed: 'Login failed, please contact administrator.',
        failedSendShareLink: 'Message not sent. Please verify the email address is valid and retry.',
        useSso: 'Use single sign-on to login.',
        enterOtpCode: 'Enter the two-factor authentication (2FA) code.',
        otpCode: 'Code',
        otpCodeInvalid: 'Code invalid.',
        invalidHost: 'Invalid URL, please try:',
        selectCompany: 'Select a company:',
    },
    profile: {
        changePassword: 'Change password',
        currentPassword: 'Current password',
        newPassword: 'New password',
        repeatNewPassword: 'Confirm new password',
        passwordAge: 'The current password is {0} days old.',
        errorPasswordsNotEqual: 'Passwords are not equal',
        errorPasswordNotCorrect: 'Incorrect password',
        errorPasswordOldSameAsNew: 'The new password cannot be the same as the current password.',
        errorPasswordTooSmall: 'Password too short. Minimum length is 8 characters.',
        errorNoPunctuation: 'password should contain at least one special character',
        messageChanged: 'Password is changed',
        twoFactorAuthentication: 'Two-factor authentication',
        twoFactorAuthenticationStepOne: 'Use an Authenticator app to scan the QR code.',
        twoFactorAuthenticationStepTwo: ' Enter the 6 digit code shown in the Authenticator app.',
        twoFactorAuthenticationIsEnabled: 'Two-factor authentication is ON.',
        twoFactorAuthenticationIsDisabled: 'Two-factor authentication is OFF.',
        twoFactorAuthenticationExplanation:
            'Two-step authentication adds an extra layer of security to your account. This verification works with Google Authenticator, FreeOTP or any other app that generates one-time verification codes.',
        twoFactorAuthenticationExplanationDisable:
            'Turning off 2-Step authentication removes the extra layer of security from your account and only uses the password to sign in.',
        otpCode: '6 digit code',
    },
    user: {
        firstName: 'First name',
        lastName: 'Last name',
        emailAddress: 'Email address',
        mobileNumber: 'Mobile number',
        officeNumber: 'Office number',
        password: 'Password',
        repeatPassword: 'Repeat password',
        language: 'Select language',
        saveUser: 'Save user',
        dutch: 'Dutch',
        english: 'English',
        statusLanguage: 'Status and language',
        errorEmailAlreadyInCompany: 'The email address provided is already in use within the company',
        errorEmailAlreadyInTenant:
            'The email address provided is already in use within your tenant. Please add the existing user or contact support.',
        errorEmailNotUnique: 'The email address provided is already in use. Please choose another e-mail address or contact support',
        errorEmailNotValid: 'The email address provided is invalid.',
        managerRoles: 'System management roles',
        isAccountManager: 'Account manager',
        isConfigurationManager: 'Configuration manager',
        isDroneOperator: 'Drone operator',
        isReadOnly: 'Read only',
        isReadOnlyExplanation: 'User can not add, edit or remove data.',
        passwordExplanation: 'If the password field is left empty, the password remains unchanged.',
        generatePasswordLink: 'Send mail to activate account',
        generatePasswordLinkExplanation: 'User will receive an e-mail containing a link to active account and create a password.',
        resetAccount: 'Recover password',
        resetAccountExplanation: 'User will receive an e-mail containing a link to create a new password.',
        pointCloudNotEnabled: 'Use of point cloud is disabled. You can change this in your profile.',
        otp: 'Multifaceted Authentication',
        resetOtp: 'Reset 2FA',
        resetOtpExplanation: 'Multi-factor authentication will be removed. The user can then log in to set up two-factor authentication (2FA).',
        emailMessage: 'Optional extra message in e-mail',
        newUser: 'New user',
        existingUser: 'Existing user',
        existingUsers: 'Existing users',
        addExistingUserToCompany: 'Add existing user to this company',
        confirmRemoveFromCompany: 'Are you sure you would like to remove "{0}" from this company?',
        administratorAddExistingUserWarning:
            'As an administrator, if you add an existing user to another company, you might accidentally add a user from one client to another. This can lead to unwanted results, so be careful.',
    },
    validation: {
        general: 'Something went wrong, please try again.',
        NOT_ALLOWED: 'Something went wrong, please contact the service desk.',
        PASSWORD_LINK_EXPIRED: 'Link is no longer valid.',
        PASSWORD_TOO_SHORT: 'Password too short. Minimum length is 8 characters.',
        PASSWORD_NO_PUNCTUATION: 'Password should contain at least one special character',
        PASSWORD_NOT_THE_SAME: 'Password and confirm password does not match',
        EMAIL_NOT_VALID: 'Not a valid email address',
        FAILED_SENDING_MAIL: 'Mail could not be sent. Contact the service desk.',
        min: '"{0}" must be larger than or equal to "{1}"',
        greater: '"{0}" must be greater than "{1}"',
        REQUIRED: 'required',
        any_empty: 'Can not be empty',
        any_required: 'Can not be empty',
        date_base: 'No valid date',
        string_base: 'Can not be empty',
        number_base: 'Must be a number',
        number_less: 'Number must be smaller',
        number_integer: 'Number must be an integer',
    },
    company: {
        storageUsed: 'Storage used',
        registeredOn: 'Registered',
        findCompany: 'Find company',
        companyName: 'Company name',
        companyRole: 'Role',
        companyCompanyRole: 'Company role',
        streetAndNumber: 'Street + number',
        details: 'Company details',
        zipCode: 'Zip code',
        city: 'City',
        state: 'State',
        country: 'Country',
        statusAndStorage: 'Status and storage',
        supportEmailAddress: 'Support email address',
        supportEmailExplanation:
            'Support requests from users are forwarded to this e-mail address. If nothing is specified, support questions go to the central e-mail address.',
        storageMb: 'Storage MB',
        addRelation: 'Add relation',
        addUser: 'Add user',
        editCompany: 'Edit company',
        relations: 'Company relations',
        relation: 'Relation',
        usage: 'Monthly statement',
        isClient: 'Company is a customer',
        isClientExplanation: 'A customer can add objects, surveys and companies.',
        saveCompanyAndAddUser: 'Save company & add user',
        authenticationToken: 'Authentication token',
        useBatches: 'Use batch model',
        useBatchesExplanation:
            'Objects are allocated in batches to an inspector or operator who thereby obtains rights to that object. These rights expire when the batch is closed. If the batch setting is not used, an inspector or operator has rights to all objects.',
        useSurveyComments: 'Use survey comments',
        useSurveyCommentsExplanation: 'Specifies if comments can be added to surveys.',
        useNen2767Advanced: 'Use NEN2767 (advanced)',
        useNen2767AdvancedExplanation: 'explanation', // TODO
        mapSettings: 'Map settings',
        clientSettings: 'Client settings',
        isPdokMapLayerAvailable: 'Dutch map layer Pdok available',
        areLabelsVisibleInOverviews: 'Labels visible in overviews',
        isDroneNoFlyMapNlAvailable: "Dutch drone 'no fly map' available",
        mapSettingsExplanation: 'Center of the map when selecting the position of an object.',
        authenticationTokenExplanation:
            'Token for connection to external systems such as an onboard drone computer. Can be left empty if it is not known what needs to be entered.',
        shouldClusterMarkers: 'Adjacent objects are merged when zoomed out',
        restrictedHostName: 'Restricted host name',
        restrictedHostNameExplanation: 'Restrict the user to hostname. Specify hostname without https.',
        shouldEnforceMfa: 'Enforce multi factor authentication',
        shouldEnforceMfaExplanation: 'All users must use multi factor authentication.',
        useEquipmentManagement: 'Use equipment management',
        useProductTitle: 'Use name "product" as survey title',
        useProductTitleExplanation: 'The title "Surveys" will be named "Products" in the UI',
        daysVisibilityFutureSurveys: 'Visibility of future surveys in days',
        daysVisibilityFutureSurveysExplanation: 'The number of days until a future inspection becomes visible on the dashboard',
        useAiChat: 'Use AI chat',
        useAiDocumentUpload: 'Use AI document upload',
        useAiDefectDetection: 'Use AI defect detection',
        aiDailyTokenLimit: 'Daily AI token limit',
        aiMonthlyTokenLimit: 'Monthly AI token limit',
    },
    licence: {
        licence: 'Licence',
        licences: 'Licences',
        activatedOnDate: 'Activated on',
        expiresOnDate: 'Expires on',
        deviceName: 'Device name',
        activatedBy: 'Activated by',
        isStandalone: 'Standalone',
    },
    project: {
        project: 'Project',
        projects: 'Projects',
        import: 'Import',
        noMeasurements: 'No measurements',
        measurement: 'Measurement',
        value: 'Value',
        scanLines: 'Scan lines',
        scanLine: 'Scan line',
        position: 'Position',
        flight: 'Flight',
        addScanLineCoordinates: 'Add coordinates',
        scanLineStartPoint: 'Start point',
        scanLineEndPoint: 'End point',
        positions: 'Positions',
        clickOnValueToEdit: 'Click on value to edit',
        remove: 'Are you sure you would like to permanently delete these measurements?',
        iconTitleProjectsAvailable: 'UT Projects available',
        removeLink: 'Remove link to measurements',
        scanLineXAxis: 'Scan line on the x-axis',
        scanLineLabel: 'Alternative label for scan line',
        positionLabel: 'Alternative label for position',
        isValidated: 'Measurement results validated',
        isValidatedMessage: 'Measurement results have not yet been validated.',
        conductedBy: 'Conducted by',
        importCsv: 'Import CSV',
        importCsvTitle: 'Import UT measurements (CSV)',
        importCsvFile: 'CSV file',
        importCsvNoFile: 'Select a CSV file first',
        importCsvFailed: 'Importing the CSV file failed',
        importCsvChooseFile: 'Browse',
        importCsvNoFileSelected: 'No file selected',
        importCsvSkippedWarning: 'Not all rows in the CSV file could be imported.',
        importCsvImportedCount: 'Imported measurements',
        importCsvSkippedCount: 'Skipped rows',
    },
    object: {
        filter: 'Filter objects',
        lastSurveyDate: 'Last survey date',
        filterByClient: 'Filter by client',
        filterByStatus: 'Filter by status',
        filterByType: 'Filter by type',
        objectName: 'Object name',
        objectCode: 'Object code',
        locationDescription: 'Location description',
        latitude: 'Latitude (nn.nnnnn)',
        longitude: 'Longitude (nn.nnnnn)',
        owner: 'Object owner',
        companyRelations: 'Company relations',
        adminSettings: 'Administrator settings',
        isPublic: 'Visible for partners',
        useModelComposition: 'Use model composition',
        saveObjectAndAddComposition: 'Save object & edit breakdown',
        customElement: 'Custom Element',
        customUnit: 'Custom Unit',
        itemCannotBeRemoved: 'Item cannot be removed because it is in use.',
        list: 'Objects list',
        filterObjectsByObjectLabel: 'Object label',
        surveyList: 'Survey list',
        objectBreakdown: 'Composition breakdown',
        areaMap: 'Area map',
        openInspectionChecklist: 'Open inspection checklist',
        notAvailable: 'Object details are not available',
        addObject: 'Add object',
        noItemsOnMap: 'There are no objects to show on the map',
        errorNoOwner: 'No owner selected',
        errorNoClient: 'No client selected',
        errorNoInspectionStandard: 'No inspection standard selected',
        errorCodeNotUnique: 'The provided code is not unique to the asset owner',
        demoObject: 'Demo object',
        demoExpDate: 'Demo expiration date',
        elementIsDefault: 'Element will be added when creating object',
        unitIsDefault: 'Unit will be added when creating object',
        usage: 'Usage',
        construction: 'Construction',
        constructionYear: 'Construction year',
        combinedConstructionYear: 'Composed of parts with different construction years',
        externalReference: 'External reference ',
        replacementIndex: 'Replacement index value',
        length: 'Length',
        width: 'Width',
        squareMeters: 'Square meters',
        trafficType: 'Traffic type',
        mainMaterial: 'Main material',
        infrastrutureType: 'Infrastructure type',
        elementGroup: 'Element group',
        structural: 'Structural',
        copyObjectTypeElementSettings: 'Copy current settings to existing elements',
        notFoundObjects: 'Not found objects',
        nonUniqueCodes: 'Non unique codes',
        managementOrganization: 'Organization',
        managementOrganizations: 'Organizations',
        showObject: 'Show object',
        copyCompositionToSimilarObjects: 'Copy composition to similar objects',
        copyCompositionFromObject: 'Copy composition from object',
        selectCompositionFromObject: 'Select object to copy',
        loadClass: 'Load class',
        area: 'Area',
        complexName: 'Complex name',
        complexCode: 'Complex code',
        codeObjectComplex: 'Code of object or complex',
        inspectionSpecific: 'inspection specific',
        zxyExchangeAccess: 'Access via ZXY Exchange',
        accessLevel: 'Access level',
        noAccess: 'No access',
        anyoneAccess: 'Anyone access',
        selectedAccess: 'Selected access',
        registeredCompanies: 'Registered companies',
        typeTooltip: 'Own object types can be defined under menu item "Settings".',
        demoTooltip: 'If an object is a demo object, it will appear anonymously under the demo login.',
        shape: 'Shape',
        line: 'Line',
        polygon: 'Polygon',
        clear: 'Clear',
        position: 'Geographical location',
        givePosition: 'Select a point on the map or draw the shape of the object on the map to indicate the geographic location.',
        hasPoint: 'Object has a point on the map',
        hasShape: 'Object has a shape on the map',
        selectPoint: 'Select a point on the map',
        drawShape: 'Draw a shape on the map',
        pdokLayer: 'Dutch map layers PDOK',
        supplier: 'Supplier',
        dimension: 'Dimension',
        strength: 'Strength',
        norm: 'Norm',
        exportShape: 'Shape file',
        exportShapes: 'Shape files',
        nenReport: 'Nen report',
        mjopReport: 'LTMP report',
        generalData: 'General data',
        height: 'Height',
        volume: 'Volume',
        palen: 'Poles',
        dragers: 'Girders',
        damwandplanken: 'Sheet piles',
        loadClassExplanation: 'Load class',
        replacementValue: 'Replacement value',
        showOtherObjects: 'Show other objects',
        showOtherObjectsExplanation: 'Zoom in to show other objects',
        nameOrCode: 'Name / Code',
        productList: 'Product list',
        lastProductDate: 'Last product date',
        labels: 'Object labels',
    },
    condition: {
        excellent: 'Excellent',
        good: 'Good',
        reasonable: 'Reasonable',
        moderate: 'Moderate',
        poor: 'Poor',
        bad: 'Very bad',
        critical: 'Critical',
        further: 'Follow-up',
        unknown: 'Unknown',
        invalid: ' ',
        orLess: '{0} or less',
        orMore: '{0} or higher',
    },
    intensity: {
        level1: 'Early stage',
        level2: 'Advanced stage',
        level3: 'Final stage',
    },
    extend: {
        level1: 'Occurs occasionally (< 2 %)',
        level2: 'Occurs locally (2 % to 10 %)',
        level3: 'Occurs frequently (10% to 30%)',
        level4: 'Occurs Regularly (30% to 70%)',
        level5: 'Common (> 70%)',
    },
    seriousness: {
        level1: 'Low',
        level2: 'Moderate',
        level3: 'Severe',
    },
    survey: {
        surveyedOn: 'Date',
        updatedOn: 'Update',
        findSurvey: 'Filter surveys',
        filterByClient: 'Filter by client',
        description: 'Survey description',
        filterOnLabel: 'Filter surveys by labels',
        filterObjectsBySurveyLabel: 'Survey label',
        filterOnDescription: 'Filter surveys by description or text in documents',
        labelsExpl: 'Labels can be used to provide additional characteristics to filter on.',
        defaultPointCloud: 'Default point cloud',
        customPointCloud: 'Custom point cloud',
        filenamePointCloud: 'Point cloud filename to be used',
        saveSurveyAndAddVisuals: 'Save & add condition',
        manageVisuals: 'Manage visuals',
        returnEditInspection: 'Return to edit survey',
        conditionAssessment: 'Condition assessment',
        editConditionAssessment: 'Edit report',
        dataAndDocuments: 'Data and documents',
        summaryAndAdvice: 'Summary',
        composition: 'Composition',
        expandAll: 'Expand all',
        collapseAll: 'Collapse all',
        expandAllComposition: 'Expand breakdown',
        collapseAllComposition: 'Collapse breakdown',
        visualsAvailable: 'Visuals available',
        selectInObjectTreeVisual: 'Select a node in the composition tree to manage photos and videos.',
        selectInObjectTreeAssessment: 'Select a leaf in the composition tree to manage findings.',
        selectInObjectTreeDataPoint:
            'There are no measurements to display. Select an end point in the composition tree under which measurements are published.',
        dragAndDropUploader: 'Drag and Drop Uploader',
        serverNotConfigured: 'Server not Configured',
        dropFiles: 'Drop files',
        toUpload: 'to upload',
        orClick: 'or click',
        dropzoneAcceptedFiles: 'Accepted file types: {0}',
        imageUsedInReport: 'Image is used in report',
        imageOnStartPage: 'Image on start page',
        commentsAvailable: 'Comments available',
        removeAllFiles: 'Remove all files',
        composeYourMessage: 'Compose your message here!',
        conditionAdvice: 'Advice',
        conditionAndAdvice: 'Conditions and advice',
        conditionCost: 'Costs',
        conditionCostYear: 'Year costs',
        conditionScore: 'Score',
        composeSummaryAndAdvice: 'Compose your summary and advice here...',
        '3dModel': '3D Model',
        documents: 'Documents',
        downloads: 'Downloads',
        surveyTab: 'Survey  ',
        pointcloudTab: 'Point cloud',
        pointClouds: 'Point clouds',
        manageVisualsTab: 'Visuals',
        conditionAssessmentTab: 'Assessment',
        summaryAndAdviceTab: 'Summary',
        generateReportTab: 'Generate report in Word format',
        mapAndAlternativeMap: 'Map and alternative map',
        open3dViewer: 'Enlarge 3D model in separate window',
        open2dViewer: 'Show in separate window',
        edit3dViewer: 'Edit in 3D viewer',
        conditionReport: 'Condition report',
        downloadPDFReport: 'PDF report',
        downloadExcelReport: 'Excel report',
        costEstimationPrefix: 'Cost estimation: € ',
        costEstimationYearPrefix: 'In year ',
        assetAddToReport: 'Add to online report',
        assetRemoveFromReport: 'Remove from online report',
        assetAddToMSWReport: 'Add to report document',
        assetRemoveFromMSWReport: 'Remove from report document',
        assetAddToStartPage: 'Publish on start page',
        assetRemoveFromStartPage: 'Remove from start page',
        processing: 'Processing...',
        overallCondition: 'Summarized general condition',
        noImages: 'There are no photos or videos for this element available.',
        storageMb: 'Storage',
        size: 'Size',
        noItemsOnMap: 'There are no items to show on the map',
        notAvailable: 'Requested survey is not available',
        isDOMLight: 'Eye-Dome lighting',
        isAnnotationsDefaultVisible: 'Annotation labels default visible',
        cancelUpload: 'System is busy uploading. Do you want to cancel?',
        pointCloudStorageUsed: 'Size point cloud (Mb)',
        conditionRepairs: 'Condition and Repair advice',
        conditionDefects: 'Condition and all defects',
        videosTab: 'Videos',
        start: 'Start',
        end: 'End',
        showReport: 'Show report',
        editReport: 'Edit report',
        noPointcloud: 'No point cloud available',
        editSurveyData: 'Edit survey data',
        assetDescriptionIsVisible: 'Description field for photos and videos available',
        isVideoDownloadVisible: 'Original video files are available for download',
        internalRemark: 'Internal comments, not visible in report',
        allElementsVisible: 'Show all elements',
        defectElementsVisible: 'Show only assessed elements',
        generateReport: 'Generate report',
        closeAnnotationWindow: 'Close annotation window',
        compositeCondition: 'Composite condition',
        compositeCare: 'Composite care ',
        recalculateDerivedCondition: 'Recalculate condition',
        resetConditions: 'Reset conditions and recalculate',
        resetDefaultMaintenance: 'Generate default maintenance measures',
        mailShareLink: 'Mail link',
        mailTo: 'Mail to',
        availability: 'Availability',
        availability2: 'Two days',
        availability14: 'Two weeks',
        availability28: 'Four Weeks',
        availability60: 'Two months',
        availability183: 'Half a year',
        availability0: 'Unlimited',
        message: 'Message',
        plyModel: 'PLY Model',
        ifcModel: 'IFC Model',
        createMiok: 'Generate MIOK report',
        investigationPriority: 'Prioritized Follow-ups',
        isFmecaAvailable: 'FMECA',
        isCraAvailable: 'Construction risk assessment',
        inspectionPlan: 'Inspection plan',
        craInitialHistory: 'Initial construction risk assessment',
        craInspection: 'Final construction risk assessment',
        craIsBuildBetween4074: 'Build between 1940-1974',
        craIsStaticallyIndeterminate: 'Is statically indeterminate',
        craInitialHistoryCondition: 'Combined initial construction risk assessment',
        craInspectionCondition: 'Combined final construction risk assessment',
        combinedRiskScores: 'Combined scores',
        surveryedOn: 'Surveyed on',
        inspectionPlans: 'Inspection plan',
        author: 'Author',
        preparedBy: 'Prepared by',
        verifiedBy: 'Verified by',
        fmecaRisk: 'FMECA risk',
        riskDefect: 'Defect risk',
        riskConstruction: 'Construction risk',
        riskFailure: 'Failure risk',
        signature: 'Signature',
        closeSurvey: 'Close survey',
        completeSurvey: 'Complete survey',
        furtherInvestigation: 'Follow-up requested',
        priorityFurtherInvestigation: 'Priority follow-up',
        closeSurveyExplanation:
            'By closing this inspection, the inspection can no longer be edited. The inspection can only be opened afterwards by a manager. Are you sure you want to close this inspection?',
        generate: 'Generate report',
        uploadConvert: 'Upload and convert point cloud',
        externalLink: 'External link',
        copyImageTo: 'Copy visual to',
        moveImageTo: 'Move visual to',
        residualLife: 'Remaining lifespan',
        residualLifeDisclaimer:
            'Note: The remaining lifespan is only an indication. The actual remaining lifespan depends on various factors that have not been taken into account here.',
        compare: 'Compare',
        selectSurveyToCompare: 'Select survey to compare',
        importDefaultMaintenance: 'Import standard measures',
        basicData: 'Basis data',
        additionalData: 'Additional data',
        copy: 'Copy inspection',
        copyExplanation:
            "When copying the inspection, the photos, videos and findings that are in the composition are copied. If the elements and units of the target object are not present, then these parts will not be copied. Before copying an inspection, make sure the target object's composition is correct.",
        imagesDisplayed: '{0} images of a total of {1} are displayed.',
        imagesLoad: 'Load more images...',
        referenceNumber: 'Reference number',
        projectOrReferenceNumber: 'Report or reference number',
        display: 'Display',
        visible: 'Visible',
        temperature: 'Temperature',
        open: 'Open survey',
        revisionNumber: 'Revision number',
        maxFileSizeExplanation: 'For {0} files, a maximum of {1} MB applies.',
        reportDeadlineOnDate: 'Deadline report',
        longRunningSurveys: 'Long running surveys',
        statusUpdatedOn: 'Status updated',
        assignmentUpdatedOn: 'Assigned on',
        allImagesSelected: 'The report now displays all available images.',
        allImagesDeselected: 'The report no longer displays any of the available images.',
        allImagesSelectFailed: 'Failed to update visibility for all images',
        selectAllImages: 'Show all images in report',
        deselectAllImages: 'Hide all images in report',
        descriptionOrNumber: 'Description / number',
        labels: 'Survey labels',
        bulkUpdateExplanation: 'Apply changes to multiple surveys at once. Will replace old values.',
        bulkUpdateSurveys: 'Bulk update {0} surveys',
        surveyImportSheetOverride: '{0}: use fixed value, ignore values from sheet',
        bulkUpdateAcceptLargeUpdate: 'Are you sure you want to apply this change to {0} surveys?',
        labelUpdateActionAdd: 'Add to existing labels',
        labelUpdateActionReplace: 'Replace existing labels',
        scopeTab: 'Scope',
        scopeEditButton: 'Edit scope',
        scopePlaceholder: 'Select an object first to determine the scope.',
        scopeNoElements: 'This object does not include elements for selecting a scope.',
        scopeSaveFailed: 'Could not save the scope. Please try again.',
        explanationTab: 'Explanation',
        explanationPlaceholder: 'Provide an explanation of the scope.',
    },
    product: {
        filterProduct: 'Filter products',
        filterOnLabel: 'Filter products by labels',
        longRunningProducts: 'Long running products',
        type: 'type',
        filterOnDescription: 'Filter products by description or text in documents',
        description: 'Product description',
        productType: 'Product type',
    },
    repairAdvice: {
        repairAdvice: 'Repair advice',
        description: 'Description of repair',
        category: 'Part',
        advice: 'Advice',
        eemua: 'Classification',
        repairDate: 'Repair date',
        add: 'Add repair advice',
    },
    repairCategory: {
        repairImmediately: 'Repair needed immediately',
        repairInSixMonths: 'Repair within 6 months',
        repairOnOccasion: 'Repair on occasion',
        repairNextRenovation: 'Repair during next major renovation',
        repairNextInspection: 'Repair before next inspection',
        noRepair: 'Repair not needed',
    },
    dashboard: {
        surveyList: 'Most recent surveys',
        futureSurveyList: 'Future surveys in the next {0} days',
        flightLogs: 'Most recent flight logs',
        account: 'My account',
        storageUsed: 'Storage used',
        companyUsagesList: 'Monthly statement used storage and objects',
        noData: 'There are currently no data available. Statement is updated on the first day of each month.',
        noSurvey: 'There are currently no surveys to display',
        faWarningTitle: '2FA is not enabled',
        faWarning1: '2FA (2-Step Verification) is not set up for your account.',
        faWarning2: 'For security reasons it is necessary to enable this. This can be easily done on the profile page.',
        goToProfile: 'Go to profile to set up 2FA',
        assignedSurveyList: 'Assigned surveys',
        assignedProductList: 'Assigned products',
        futureProductList: 'Future products in the next {0} days',
        recentProductList: 'Most recent products',
    },
    support: {
        support: 'Support',
        myData: 'Contact details',
        supportHeader: 'Need support? We are here to help!',
        callMeBack: 'Call me back',
        yes: 'Yes',
        no: 'No',
        question: 'Your support question',
        submit: 'Send support request',
        submitted: 'You request has been submitted. We will contact you as soon as possible.',
    },
    video: {
        video: 'Video',
        videos: 'Videos',
        create: 'Create a clip',
        playFragment: 'Play clip',
        saveFragment: 'Save clip',
        saveStill: 'Save still',
        saved: 'Saved clips & stills',
        titleInput: 'Title',
        downscaling: 'Downscaling in progress. Please wait. (Status Low-High: ',
        jobError: 'An error occurred while downscaling the video. Please try again.',
        jobCancelled: 'The downscaling of the video was cancelled.',
        generating: 'Generating. Please wait...',
        copySelection: 'Copy previous selection',
        options: 'Options',
        forcePanorama: 'Uploaded videos are 360° videos',
    },
    errorPages: {
        generalTitle: 'Shoot! Something went wrong',
        authorizationTitle: "We're sorry, but there's a problem with authorizations",
        generalBody: 'An error has occurred and we’re working to fix the problem.',
        authorizationBody: 'An error has occurred because there are insufficient permissions.',
        authorizationBody2: 'Try again by reloading the page or go to the',
        generalBody2: ' You could try once more or go to the ',
        goToDashboard: 'dashboard',
        needHelp: 'If you need help from our team',
        generalSendEmail: 'please contact us.',
        errorRegistration: 'The error is stored with number: ',
    },
    failureMode: {
        failureMode: 'Failure mode',
        failureModes: 'Failure modes',
        allFailureModes: 'All failure modes',
        analysis: 'Analysis',
        verification: 'Verification',
        verificationResult: 'Inspection results',
        maintenance: 'Maintenance',
        analysisRiskScoreTableHeader: 'I-ORA',
        verificationRiskScoreTableHeader: 'V-ORA',
        maintenanceRiskScoreTableHeader: 'D-ORA',
        functionAndFailureMode: 'Function & failure mode',
        failureCauseAndOrigin: 'Failure cause & origin',
        failureCause: 'Failure cause',
        failureOrigin: 'Failure origin',
        effectOfFailure: 'Effect of failure',
        analysisQuestions: 'Analysis questions',
        clarification: 'Clarification',
        analysisVerificationQuestion: 'Verification question',
        riskScoreHeader: 'Risk score',
        analysisDataHeader: 'Function, failure mode, cause and origin',
        verificationRiskScoreHeader: 'Verification risk after inspection',
        maintenanceRiskScoreHeader: 'Target risk after maintenance',
        findings: 'Findings',
        finding: 'Finding',
        risk: 'Risk',
        riskScore: 'Risk score',
        riskScoreVerification: 'Risk score after verification',
        riskScoreMaintenance: 'Risk score after maintenance measures',
        maintenanceMeasures: 'Maintenance measures',
        maintenanceMeasure: 'Maintenance measure',
        copyFromUnit: 'Copy failure mode from unit to manifestation',
    },
    maintenanceMeasure: {
        maintenanceMeasures: 'Maintenance measures',
        maintenanceMeasure: 'Maintenance measure',
        openMaintenanceMeasures: 'Measures to be implemented',
        default: 'Default maintenance measures',
        workType: 'Type work',
        maintenanceType: 'Class',
        urgency: 'Urgency',
        year: 'Plan year',
        finalPlanYear: 'Final year',
        cycle: 'Cycle',
        unitPrice: 'Unit price',
        costSurcharge: 'Cost surcharge',
        correctiveMaintenance: 'Corrective maintenance',
        preventiveMaintenance: 'Preventive maintenance',
        reasonToUpdate: 'Reason to update',
        scheduledYear: 'Scheduled year',
        implementationYear: 'Implementation year',
        scheduledYearRemarks: 'Scheduled year remarks',
        planYearRemarks: 'Plan year remarks',
        close: 'Close maintenance measures',
        closeQuestion: 'Are you sure you would like to close the maintenance measures?',
        planned: 'Planned',
        completed: 'Implemented',
        showScore: 'Show score',
        moreThan200Items: '{0} maintenance measures are found, only 200 are shown',
    },
    batch: {
        batch: 'Batch',
        batches: 'Batches',
        objectCount: 'Number of objects',
        addMultipleObjects: 'Add collection of objects',
        explanationAddMultipleObjects: 'Add multiple objects at once. Each object to add must be on a separate line with the code of that object.',
        executor: 'Executor',
        showObjectsNotInSelection: 'Show objects not in selection',
        canSelectCompletedBatches: 'Show completed batches',
        removeAllObjects: 'Remove all objects',
        multipleExecutorsWarning: 'Company "{0}" is also an executor in batch "{1}".',
        noActiveBatchesForObject: 'There are no active batches available for this object.',
        timelineTooltip: 'Planned: {0} - {1}\nActual: {2} - {3}',
        plannedDate: 'Planned date',
        implementationDate: 'implementation date',
        batchSearchPeriodType: 'Planned date period',
        notSelected: 'No batch selected',
        showRelatedBatches: 'Show related batches',
        hideRelatedBatches: 'Hide related batches',
        noRelatedBatches: 'There are no related batches',
    },
    batchSearchPeriodTypes: {
        activeInPeriod: 'Active in period',
        endsInPeriod: 'Ends in period',
        startsInPeriod: 'Starts in period',
    },
    report: {
        conditionReport: 'Condition report',
        inspectionReport: 'Inspection report',
        dateInspection: 'Inspection date',
        dateReport: 'Report date',
        inspector: 'Inspector',
        images: 'Visuals',
        imagesExplanation: 'Supporting visual material in the condition report',
        noImages: 'No photos available or no photos selected for',
        notAvailable: 'Generating reports in docx format is currently only available for EEMUA inspections.',
    },
    totalRiskScoreEnum: {
        '1': 'Acceptable',
        '2': 'Undesirable',
        '3': 'Unacceptable',
    },
    inspectionStandard: {
        inspectionTypes: 'Inspection types',
        nen2767: 'NEN 2767',
        eemua159: 'EEMUA 159 ',
        api653: 'API 653',
        api570: 'API 570',
        fmeca: 'Conservation',
        free: 'Free',
        memo: 'Memo',
        model3d: '3D model',
        verificatieBerekening: 'Verificatie berekening',
        undefined: 'undefined',
    },
    status: {
        open: 'Open',
        active: 'Active',
        completed: 'Completed',
        deleted: 'Deleted',
        proposal: 'Proposal',
    },
    objectStatus: {
        underConstruction: 'Under construction',
        inUse: 'In service',
        inMaintenance: 'In maintenance',
        outOfService: 'Out of service',
        cancelled: 'Cancelled',
        deleted: 'Deleted',
    },
    surveyStatus: {
        open: 'Open',
        conducting: 'Executing',
        completed: 'Completed',
        disabled: 'Disabled',
        deleted: 'Deleted',
        delivery: 'Delivering',
        preparation: 'Preparing',
        reporting: 'Reporting',
        undefined: 'Undefined',
    },
    batchStatus: {
        open: 'Open',
        active: 'Active',
        completed: 'Completed',
        deleted: 'Deleted',
        proposal: 'Proposal',
    },
    ramsPriority: {
        null: ' ',
        '0': ' ',
        '1': 'Repair >5 years',
        '2': 'Repair  3-5 year',
        '3': 'Repair 1-2 year',
        '4': 'Direct Repair',
    },
    damage: {
        cause: 'Damage cause',
        location: 'Location description',
        details: 'Damage details',
        advice: 'Repair advice',
        collision: 'Collision',
        carbonation: 'Carbonation',
        corrosion: 'Corrosion',
        leakage: 'Leakage',
        applied: 'Not (correctly) applied',
        executed: 'Not (correctly) executed',
        washout: 'Washout',
        vandalism: 'Vandalism',
        pollution: 'Pollution',
        aging: 'Aging',
        deformation: 'Deformation',
        blockage: 'Blockage',
        settlement: 'Settlement',
        other: 'Other',
    },
    rams: {
        reliability: 'Reliability',
        availability: 'Availability',
        safety: 'Safety',
        consequentialCosts: 'Consequential costs',
        environment: 'Environment',
    },
    ramsDescription: {
        reliability: 'Manifestation of risk',
        availability: 'Fraction of time that object is not functioning',
        safety: 'Occupational health and safety',
        consequentialCosts: 'The total corrective costs for repairs',
        environment: 'Negative effect on environment',
    },
    fmecaRisk: {
        '1': 'Low risk',
        '2': 'Below average risk',
        '3': 'Above average risk',
        '4': 'High risk',
    },
    investigationPriority: {
        '0': 'Unknown',
        '1': 'Low',
        '2': 'Middle',
        '3': 'High',
    },
    elementGroupName: {
        superstructure: 'Superstructure',
        substructure: 'Substructure',
        foundation: 'Foundation',
    },
    cra: {
        cra: 'Construction risk assessment',
        riskAssessment: 'Risk assessment',
        filterConstructionElements: 'Filter construction elements',
        constructionRiskAssessment: 'Construction risk assessment',
        unityCheck: 'Unity check',
        initialDesignAndModifications: 'Initial design and modifications',
        historicalSurveysAndCurrentCalculations: 'Historical surveys and current calculations',
        riskScore0: 'Unknown',
        riskScore1: 'Low risk',
        riskScore2: 'Below average risk',
        riskScore3: 'Above average risk',
        riskScore4: 'High risk',
        riskScoreNull: ' ',
        currentVerification: 'Current verification',
        craMaxInitialScore: 'Combined risk score original design and modifications',
        craMaxHistoryScore: 'Combined risk score historical inspections, existing calculations',
        craMaxInspectionScore: 'Combined risk score historical inspection',
        initial: 'Initial',
        inspection: 'Inspection',
        inspectionFindings: 'Findings',
        riskScore: 'Unknown',
        riskScoreUndefined: 'Unknown',
        history: 'History',
    },
    fmecaFurtherInvestigation: {
        furtherInvestigation: 'Further investigation',
        priority1: 'Low',
        priority2: 'Medium',
        priority3: 'High',
    },
    inspectionLabel: {
        scubaInspection: 'Scuba inspection',
        rovInspection: 'ROV inspection',
        droneInspection: 'Drone inspection',
        traditionalInspection: 'Traditional inspection',
        inspectionLoad: 'Inspection load',
        cost: 'Cost',
        risk: 'Risk',
        inspectorRisk: 'Inspector',
        surroundingsRisc: 'Surroundings',
        aviationRisc: 'Aviation',
        objectRisc: 'Object',
        traffic: 'Traffic',
        environment: 'Environment',
        nuisance: 'Nuisance',
        cO2emissions: 'CO2 emissions',
        efficiency: 'Efficiency',
        detectionEfficiency: 'Detection efficiency',
    },
    PotreeConverter: {
        jobs: 'Running jobs',
        geoConversion: 'Geo reference conversion',
        none: 'None',
        rds: 'Dutch triangle system',
        wgs84: 'WGS 84 (GPS)',
        utmZone: 'UTM zone',
        maxFileSize:
            'For .las files, a maximum of 4 Gb applies. For .laz files the maximum is 1.5 Gb. Larger files can be converted by contacting ZXY-Cloud.',
    },
    worker: {
        jobs: 'Jobs',
        runningJobs: 'Running jobs',
        finishedJobs: 'Finished jobs',
        uploadZip: 'Bulk upload images in zip file',
        compressedImages:
            'Images in a zip file can be uploaded. The directory structure in the zip file is created as composition. This structure can be three levels deep (example: element/unit/manifestation), deeper structures are ignored.',
        lastJobFailed: 'Last job failed',
        potreeFailedWithExitCodeNull:
            'Job failed because the point cloud could not be converted, likely due to an incomplete or invalid file. Please check the point cloud. You can also resample it using a program like Cloud Compare and try uploading it again.',
    },
    equipment: {
        management: 'Equipment management',
        equipment: 'Equipment',
        types: 'Equipment types',
        inUse: 'In use',
        inMaintenance: 'In maintenance',
        outOfService: 'Out of service',
        deleted: 'Deleted',
        underConstruction: 'Under construction',
        expirationDate: 'Expiration date',
        reminderDate: 'Date reminder expiration',
        expireSoon: 'Equipment that will expire soon',
        expiresIn: 'Expires in',
        noExpirations: 'There is no equipment that will expire soon.',
        isPayload: 'Part of a parent system',
        gridView: 'Grid view',
        listView: 'List view',
        usedEquipment: 'Used equipment',
        payload: 'Payload',
        carrier: 'Carrier',
        general: 'General',
        incident: 'Incident',
        modification: 'Modification',
        repair: 'Repair',
        manufacturer: 'Manufacturer',
        typeIndication: 'Type indication',
        serialNumber: 'Serial number',
        softwareVersion: 'Software version number',
        hasLog: 'Contains a log',
        flightLogExport: 'Export flight log to Excel',
        customFields: 'Custom fields',
        fieldName: 'Field name',
        fieldOrder: 'Order',
        addField: 'Add field',
        noFieldsDefined: 'No custom fields defined for this equipment type.',

        // BE stuff
        historyReportFilename: 'History-{0}-{1}',
        sheetName: 'My Sheet',
        dateHeader: 'Date',
        typeHeader: 'Type',
        descHeader: 'Description',
    },
    flightLog: {
        log: 'Flight Log',
        attachDeviceFirst: 'Please add some equipment first!',
        entry: 'Log entry',
        duration: 'Flight time',
        pilot: 'Pilot',
        mins: '{0} min(s)',
        minutes: 'Minutes',
        equipment: 'Equipment',
        droneOperator: 'Drone operator',
        ndtInspector: 'NDT inspector',
        selectPilotPlaceholder: 'Select drone operator',
        pilotIsRequired: '"Pilot" is required',
        selectEquipmentLabel: 'Used Equipment',
        selectEquipmentPlaceholder: 'Select equipment',
        equipmentIsRequired: '"Equipment" is required',
        flightDateLabel: 'Execution date',
        flightDateRequired: '"Flight date" is required',
        flightDurationRequired: '"Flight duration" is required',
        assetBasedRemarkStub: "Created based on '{0}' file",
        projectBasedRemarkStub: "Created based on '{0}' project",
        generateLogFromVideos: 'Generate log from videos',
        generateLogsFromMeasurements: 'Generate log from UT data',
        deleteAllInSurvey: 'Delete all flight logs',
        confirmDeleteAll: 'Are you sure you would like to remove all flight logs within this survey?',
        selectAssetLabel: 'Select asset to use its metadata',
        selectAssetPlaceholder: 'Select file to start with',
        batchCreateBasedOnVideos: 'Batch create of flight logs for all videos',
        selectProjectPlaceholder: 'Select project to use its measurements',
        selectProjectLabel: 'Select project to start with',
    },
    assetType: {
        Document: 'Document',
        MeasurementXLS: 'Excel',
        MeasurementPDF: 'PDF',
        Image: 'Image',
        Video: 'Video',
        DerivedImage: 'Image',
        DerivedVideo: 'Video',
        ZipArchive: 'Zip-Archive',
        TarArchive: 'Tar-Archive',
        BIM: '3D-model, BIM, CAD',
        '3DModel': '3D-model',
        AutoCad: 'AutoCAD',
        Text: 'Plain text',
        Image360: 'Panorama photo',
        ImageTif: 'Tiff image',
        ImageAnnotation: 'Annotated image',
        IfcModel: 'IFC, BIM model',
        Import: 'Import file',
    },
    trafficType: {
        pedestrian: 'Pedestrian',
        cyclist: 'Cyclist',
        car: 'Car',
        train: 'Train',
        tram: 'Tram',
        subway: 'Subway',
        vessel: 'Vessel',
        non: 'Non',
    },
    objectTypeField: {
        fields: 'Fields',
        additionalData: 'Additional data',
        objectTypeFields: 'Object type fields',
        objectTypeField: 'Object type field',
        unit: 'Unit',
        dataType: 'Data type',
        listOptions: 'List options',
        category: 'Category',
    },
    objectTypeFieldDataType: {
        string: 'String',
        number: 'Number',
        list: 'List',
        boolean: 'Boolean',
    },
    NEN: {
        report: 'Rapport',
    },
    FMECA: {
        report: 'Rapport',
    },
    objectRelation: {
        parent: 'Parent',
        child: 'Child',
        objectRelation: 'Object relation',
        objectRelations: 'Object relations',
        useObjectRelations: 'Use object relations',
        useObjectRelationsExplanation: 'When enabled, objects can have parent/child relations to each other.',
        childOfRelations: 'Child',
        parentOfRelations: 'Parent',
    },
    workflow: {
        workflow: 'Workflow',
        assignment: 'Assignment',
        checklist: 'Checklist',
        comments: 'Comments',
        addComment: 'Add comment',
        comment: 'Comment',
        assignedTo: 'Assigned',
        unassigned: 'Unassigned',
        lastComment: 'Last comment',
        noComment: 'No comment available',
        task: 'Task',
        updatedBy: 'Updated by',
        editChecklist: 'Edit checklist',
        notify: 'Notify',
        involvedPersons: 'Involved persons',
        employee: 'Employee',
        filter: 'Filter tasks',
        linkToDocuments: 'Link to documents',
        openLinkToDocuments: 'Open link to documents',
        linkToDocumentsNotSet: 'Link to documents not set',
        daysFutureSurveys: 'Days future surveys',
    },
    surveyTaskProgressStatus: {
        open: 'Open',
        completed: 'Completed',
        inProgress: 'In progress',
        notApplicable: 'Not applicable',
    },
    surveyWorkflowRoles: {
        accountManager: 'Account manager',
        pilot: 'Pilot',
        inspector: 'Inspector',
        reporter: 'Reporter',
        validator: 'Validator',
    },
    videoStream: {
        videoStream: 'Video stream',
    },
    inspectionForms: {
        title: 'Inspection forms',
        form: 'inspection form',
        filter: 'Filter inspection forms',
        template: 'Template',
    },
    label: {
        labelText: 'Label text',
        searchLabels: 'Search labels',
        pleaseFirstSelectAClient: 'Please first select a client.',
    },
    ai: {
        configuration: 'Configuration',
        chatModel: 'Chat model',
        embeddingModel: 'Embedding model',
        region: 'Region',
        status: 'Status',
        connected: 'Connected',
        notConfigured: 'Not configured',
        testChat: 'Test Chat',
        send: 'Send',
        placeholder: 'Type a message to test AI...',
        tokensUsed: 'Tokens used',
        you: 'You',
        thinking: 'Thinking...',
        newConversation: 'New conversation',
        errorOccurred: 'An error occurred',
    },
    chat: {
        openObjectChat: 'Ask a question about this object',
        openSurveyChat: 'Ask a question about this survey',
        openGeneralChat: 'Ask a question',
        // {0} is filled with the user's first name; greeting shown only on
        // a fresh conversation.
        greeting: 'How can I help you, {0}?',
        greetingNoName: 'How can I help you?',
        chatAboutObject: 'Chat about {0}',
        chatAboutSurvey: 'Chat about {0}',
        chatGeneral: 'General AI Chat',
        send: 'Send',
        stop: 'Stop',
        startNewChat: 'New chat',
        maxMessagesReached: 'This chat has reached the limit of 50 messages. Please start a new chat on this topic.',
        placeholder: 'Type your question…',
        you: 'You',
        assistant: 'ZXY Cloud',
        progressMessages: [
            'Thinking…',
            'Interesting…',
            'I’m on it…',
            'Working…',
            'Let’s have a look…',
            'Reading…',
            'Digging…',
            'I need to investigate this further…',
            'Still working…',
            'Sorry, I’m almost there…',
            'Not an easy question for me…',
            'Phew…',
            'I’m doing the best I can…',
            'Sorting my findings…',
            'Got it…',
        ],
        disclaimer: 'The chat is still in beta and may return incorrect or incomplete information. Always verify the results.',
        refusalWriteAction: 'Sorry, I cannot modify, add or delete data. I don’t have the rights to do that.',
        sourcesLabel: 'Sources',
        interruptedLabel: 'Interrupted — the response may be incomplete.',
        noContextAvailable: 'No context available for this chat.',
    },
};
